import React from 'react';
import {View, Text, StyleSheet} from 'react-native';
import {FONT_FAMILY_BOLD} from "../../constants/styleConstants";
import {actuatedNormalize} from "../../services/helpers/stylingHelpers";
import LiveClock from "../../components/LiveClock";
import {useSelector} from "react-redux";
import {getConfig} from "../../reducers/configSlice";

const RoomInfo = () => {
    const config = useSelector(getConfig)

    return (
        <View style={[styles.header, config.hide_header_info && {opacity: 0}]}>
            <Text style={styles.companyName}>
                {config && config.title}
            </Text>
            <LiveClock/>
        </View>
    );
};

const styles = StyleSheet.create({
    header: {
        flex: 0.19,
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
    },
    companyName: {
        color: 'white',
        fontFamily: FONT_FAMILY_BOLD,
        fontSize: actuatedNormalize(23),
        flex: 1
    },
});

export default RoomInfo;
